import { Link } from 'react-router-dom';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function TestimoniosCTA() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });

  return (
    <section ref={ref} className="w-full bg-white py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="max-w-4xl mx-auto bg-brand-gray-50 rounded-3xl p-10 md:p-16 text-center" style={style}>
          <h2 className="font-serif text-brand-black text-[clamp(1.8rem,3vw,2.5rem)] font-semibold leading-[1.2]">
            ¿Quieres compartir tu <span className="italic text-brand-gray-300">experiencia</span>?
          </h2>
          <p className="font-sans text-brand-gray-500 text-base leading-[1.8] mt-5 max-w-lg mx-auto">
            Si ya has sido cliente de nuestro atelier, nos encantaría conocer tu opinión.
            Tu feedback nos ayuda a seguir mejorando y a dar la bienvenida a nuevas clientas.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contacto"
              className="inline-flex items-center justify-center bg-brand-black text-white font-sans text-[13px] tracking-widest uppercase px-8 py-4 rounded-md hover:bg-brand-gray-800 transition-colors duration-300 whitespace-nowrap"
            >
              Dejar mi opinión
            </Link>
            <Link
              to="/alta-costura"
              className="inline-flex items-center justify-center border border-brand-gray-300 text-brand-black font-sans text-[13px] tracking-widest uppercase px-8 py-4 rounded-md hover:bg-brand-gray-50 transition-colors duration-300 whitespace-nowrap"
            >
              Reservar cita
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}